import gql from "graphql-tag";

export const siteLanguageFragment = gql`
  fragment SiteLanguageFragment on SiteLanguage {
    id
    language
    name
    isActive
    domain
  }
`;

export const siteLanguageDetailsFragment = gql`
  ${siteLanguageFragment}
  fragment SiteLanguageDetailsFragment on SiteLanguage {
    ...SiteLanguageFragment
    domain
    language
    checkoutPopupImage
  }
`;
